<template>
  <v-container
    style="overflow: hidden"
    fluid
    class="fill-height ma-0 pa-0 w500 login"
  >
    <div class="row fill-height">
      <div class="col-12 col-md-6 bg-image hidden-sm-and-down">
        <div class="d-flex fill-height justify-center align-center">
          <img width="50%" src="../assets/img/logo-white.svg" alt="" />
        </div>
      </div>
      <div class="col-12 col-md-6 d-flex align-center justify-center">
        <div class="flex md7 xs11 card">
          <div class="card-titulo mb-10">
            {{ $t('login.faca_login') }}
          </div>

          <p v-if="mensagemErro" class="red--text">
            {{ mensagemErro }}
          </p>

          <v-form class="row">
            <input-text
              v-model="form.login"
              :disabled="carregando"
              class="col-12"
              :label="$t('login.login')"
              obrigatorio
              :auto-focus="true"
              @enter="autenticar"
            >
              <template #prepend-inner>
                <v-icon> $email </v-icon>
                <v-divider vertical class="mx-2" />
              </template>
            </input-text>
            <input-text
              v-model="form.password"
              :disabled="carregando"
              class="col-12"
              :label="$t('login.senha')"
              obrigatorio
              type="password"
              :auto-focus="false"
              @enter="autenticar"
            >
              <template #prepend-inner>
                <v-icon> $lock </v-icon>
                <v-divider vertical class="mx-2" />
              </template>
            </input-text>
          </v-form>

          <botao-padrao
            class="mt-6 botao-padrao-fill"
            :carregando="carregando"
            @click="autenticar"
          >
            {{ $t('login.acessar') }}
          </botao-padrao>
        </div>
      </div>
    </div>
  </v-container>
</template>
<script>
import AutenticacaoService from '@common/services/AutenticacaoService';
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      form: {
        login: '',
        password: '',
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
      carregando: false,
      mensagemErro: '',
      ipUsuario: null,
      datas: [],
      feriados: [],
    };
  },
  computed: {
    acessarHabilitado: function () {
      return this.form.login && this.form.password;
    },
  },
  mounted() {
    this.buscarIpUsuario();

    this.$store.dispatch('Layout/alterarTituloPagina', 'Login');
    this.$store.dispatch('Layout/terminarCarregamento');
  },
  methods: {
    ...mapActions('Autenticacao', ['alterarIdiomaSelecionado']),
    autenticar: async function () {
      if (!this.acessarHabilitado) return;
      this.carregando = true;
      if (!this.ipUsuario) {
        await fetch('https://api.ipify.org?format=json')
          .then((res) => res.json())
          .then((data) => (this.ipUsuario = data.ip));
      }
      let auth;
      await AutenticacaoService.autenticar({
        ...this.form,
        enderecoIP: this.ipUsuario,
      })
        .then((res) => {
          auth = res;
        })
        .catch((erro) => {
          this.carregando = false;
          if (erro?.response?.data.errors !== undefined)
            this.mensagemErro = this.$t(
              `geral.erros.${erro.response.data.errors[0]}`
            );
        });

      if (!auth) return;
      const encoded = JSON.parse(atob(auth.data.token.split('.')[1]));
      this.$store.dispatch('Autenticacao/autenticar', {
        tokenData: auth.data,
        encodedData: encoded,
      });

      this.verificarIdioma();
      if (this.$route?.params?.redirect)
        await this.$router.push(this.$route.params.redirect);
      else await this.$router.push('/dashboard');
    },
    buscarIpUsuario: async function () {
      const controller1 = new AbortController();
      const controller2 = new AbortController();

      const request1 = fetch('https://api.ipify.org', {
        signal: controller1.signal,
      });
      const request2 = fetch('https://checkip.amazonaws.com/', {
        signal: controller2.signal,
      });

      await Promise.race([request1, request2])
        .then((response) => {
          // Cancela a outra requisição
          if (response.url.includes('api.ipify.org')) {
            controller2.abort();
          } else {
            controller1.abort();
          }

          // Lida com a resposta da requisição que retornou primeiro
          return response.text();
        })
        .then((data) => {
          this.ipUsuario = data;
        })
        .catch((error) => {
          if (error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error:', error);
          }
        });
    },
    verificarIdioma() {
      this.alterarIdiomaSelecionado('pt-BR');
      const idiomas = this.$store.getters['Autenticacao/idiomas'];
      const idioma =
        this.$route.params.idioma || localStorage.getItem('idioma');
      const buscarIdioma = idiomas?.find((i) =>
        i?.toLowerCase().includes(idioma?.toLowerCase())
      );

      if (idioma && buscarIdioma) this.$i18n.locale = buscarIdioma;
      else this.$i18n.locale = (idiomas && idiomas[0]) || 'pt-BR';

      localStorage.setItem('idioma', this.$i18n.locale);
    },
  },
};
</script>
<style lang="scss">
.login {
  .card {
    color: $color-primary-grey-900;

    &-titulo {
      font-size: 36px;
      line-height: 48px;
    }

    &-subtitulo {
      color: $color-primary-grey-500;
    }
  }
  .bg-image {
    background: #13539b;
    background: linear-gradient(90deg, #13539b 0%, #1659a0 49%, #528eca 100%);
  }
  .botao-padrao {
    text-transform: uppercase !important;
    .v-btn__content {
      justify-content: center;
    }
  }
}
</style>
